export default {
  ElementFullWidth: 'full-width'
}
